import axios from 'axios';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import AdminLayout from '../../Componets/AdminLayout';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';
import Swal from 'sweetalert2';

export default function List() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');

  // Check if user role is ADMIN
  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
    fetchRecords();
    // eslint-disable-next-line
  }, [navigate]);

  // Function to fetch records with pagination
  const fetchRecords = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${apiUrl}/api/subject-objective/`, {
        headers: {
          Authorization: token,
        },
      });
      setRecords(response.data.subjectObjectives);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching records:', error);
      setLoading(false);
      error.response?.status === 401 && navigate('/');
    }
  };

  // Function to handle deletion of a Program Objectives
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure you want to delete this ?',
      showCancelButton: true,
      confirmButtonColor: '#0d6efd',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(
          `${apiUrl}/api/subject-objective/${id}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        setRecords(records.filter((record) => record.id !== id));
        toast.success(response.data.message);
      } catch (error) {
        toast.error(error.response?.data?.message);
        if (error.response?.status === 401) {
          navigate('/');
        }
      }
    }
  };

  const columns = [
    {
      name: 'No',
      selector: (row, index) => (row.id === 'summary' ? '' : index + 1),
      width: '50px',
      center: true,
    },

    {
      name: 'Subject Objectives',
      selector: (row) => row.objectiveName,
      sortable: true,
      cell: (row) => (
        <span className="text-wrap text-break">{row.objectiveName}</span>
      ),
    },
    {
      name: 'Actions',
      width: '115px',
      center: 'true',
      cell: (row) => (
        <div>
          <button
            onClick={() =>
              navigate('/ObjectiveEdit', { state: { id: row.id } })
            }
            className="btn btn-primary btn-sm mx-2"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Edit Subject Objectives"
          >
            <i className="bi bi-pencil-square"></i>
          </button>
          <button
            className="btn btn-outline-danger btn-sm "
            onClick={() => handleDelete(row.id)}
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Delete Subject Objectives"
          >
            <i className="bi bi-trash3-fill"></i>
          </button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <main id="main" className="main">
        <AdminLayout ac14="active" dr="true">
          <div className="pagetitle ">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item ">
                  <Link to="/AdminHome">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">
                  View Subject Objectives ({records.length})
                </li>
              </ol>
            </nav>
          </div>
          <hr className="mb-0" />
          <div className="row">
            <div className="container ">
              <div className="datatable-top">
                <div className="datatable-search">
                  <div className="datatable-search ">
                    <input
                      className="form-control"
                      type="search"
                      name="totalMarks"
                      placeholder="Search"
                      title="Search within table"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => navigate('/ObjectiveAdd')}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Add New Subject Objectives "
                  >
                    <i className="bi bi-plus-square"></i>
                  </button>
                </div>
              </div>
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={records.filter((record) =>
                    record.objectiveName
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  )}
                  progressPending={loading}
                  pagination
                  className="custom-table"
                />
                <ToastContainer
                  position="top-center"
                  style={{ width: 'auto' }}
                />
              </div>
            </div>
          </div>
        </AdminLayout>
        <Tooltip id="my-tooltip" />
      </main>
    </div>
  );
}
